import { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react';
import { IPageStatus } from './config/IPageStatus';

interface ProductState {
    timeLine: any;
    pageStatus: IPageStatus;
    productTabActive: string;
    productPageData: any;
    pageType: string;
    productInfo: any[];
}

type ProductAction = {
    type: string;
    payload: any;
};

const initState: ProductState = {
    pageStatus: IPageStatus.statusA,
    timeLine: null,
    productTabActive: '',
    productPageData: {},
    pageType: '',
    productInfo: [],
};

const fsReducer = (state: ProductState, action: ProductAction): ProductState => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        case 'changeProductTabActive':
            return { ...state, productTabActive: payload };
        case 'changeProductPageData':
            return { ...state, productPageData: payload };
        case 'changeProductInfo':
            return { ...state, productInfo: payload };
        default:
            return state;
    }
};

export const ProductContext = createContext<{ state: ProductState; dispatch: Dispatch<ProductAction> }>({
    state: initState,
    dispatch: () => null,
});

export function ProductProvider({ children, ...props }: { children: ReactNode; state?: any }) {
    const [state, dispatch] = useReducer(fsReducer, Object.assign(initState, props.state || {}));
    return <ProductContext.Provider value={{ state, dispatch }}>{children}</ProductContext.Provider>;
}

export const useProductStore = () => {
    const store = useContext(ProductContext);
    return store.state;
};

export const useProductDispatch = () => {
    const store = useContext(ProductContext);
    return store.dispatch;
};
